
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledNumberCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function ProjectCommunityTreesDistributedHeader() {
	return (
		<StickyNumericHeader
			style={{
				...offsetOneRow,
				width: '120px',
				minWidth: '120px',
				maxWidth: '120px'
			}}>
			Community trees dist.
		</StickyNumericHeader>
	)
}

export function ProjectCommunityTreesDistributedFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyNumericHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.ProjectCommunityTreesDistributedValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							ProjectCommunityTreesDistributedValidated: e.value
						})
					}
				/>
				<NumericFilter
					value={filter?.ProjectCommunityTreesDistributed ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							ProjectCommunityTreesDistributed: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyNumericHeader>
	)
}

export function ProjectCommunityTreesDistributedContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledNumberCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunityTreesDistributedValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>
					{ppn.PlantingProject.CommunityTreesDistributed?.toLocaleString()}
				</span>
			</CellWithValidator>
		</StateStyledNumberCell>
	)
}